function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCartSmallBlue = function SvgCartSmallBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14.779,
    viewBox: "0 0 16 14.779",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon ionic-ios-cart"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1887",
    d: "M12.938 29.813a1.688 1.688 0 1 1-1.687-1.688 1.688 1.688 0 0 1 1.688 1.688z",
    transform: "translate(-6.546 -16.722)",
    style: {
      fill: "#196cca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1888",
    d: "M28.723 29.813a1.687 1.687 0 1 1-1.687-1.688 1.687 1.687 0 0 1 1.687 1.688z",
    transform: "translate(-16.621 -16.722)",
    style: {
      fill: "#196cca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1889",
    d: "M19.376 6.685a.221.221 0 0 0-.2-.135L6.645 5.539a.4.4 0 0 1-.289-.151 3.279 3.279 0 0 0-.469-.6c-.3-.3-.854-.292-1.878-.3-.346 0-.627.167-.627.453s.265.453.6.453a6.107 6.107 0 0 1 1 .061c.181.045.327.292.381.507a.011.011 0 0 0 0 .01c.008.039.077.327.077.331L6.983 13.1a2.292 2.292 0 0 0 .558 1.146 1.658 1.658 0 0 0 1.266.52h9.1a.516.516 0 0 0 .554-.43.493.493 0 0 0-.539-.469H8.8a.509.509 0 0 1-.319-.09 1.36 1.36 0 0 1-.442-.835l-.165-.761a.018.018 0 0 1 .015-.019l10.685-1.509a.206.206 0 0 0 .189-.167l.616-3.717a.154.154 0 0 0-.003-.084z",
    style: {
      fill: "#196cca"
    },
    transform: "translate(-3.382 -4.493)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCartSmallBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cart_small_blue.2894552e.svg";
export { ForwardRef as ReactComponent };